export default __webpack_public_path__ + "static/media/headphone_disabled.b3d2893d.svg";